interface IPageInfo {
  page_name: string;
  page_url: string;
}

export interface IPdfItem {
  id: number;
  name: string;
  url: string;
}

interface IChapterInfo {
  category: string;
  id: number;
  is_content_unit: boolean;
  name: string;
  need_publish: boolean;
  parent_id: number;
  lowest_real_unit?: boolean;
  status?: '上线' | '下线' | '即将上线';
  children?: IChapterInfo[];
  ai_engine_id: string;
  book_unit_name?: string;
  ai_engine_type?: string;
}

export interface IBookInfoData {
  book_info: {
    grade: string;
    name: string;
    page_count: string;
    publisher: string;
    term: string;
    title: string;
    unit_type: string;
    ai_product_book_rel_id: number;
  };
  chapter_info: IChapterInfo[];
  page_list: IPageInfo[];
  jsonurl: string;
}

export function flatUnitEnter(chapterArr: IChapterInfo[]) {
  const list: IChapterInfo[] = [];

  function flatUnit(item: IChapterInfo, list: IChapterInfo[]) {
    const { children, ...rest } = item;

    list.push(rest);

    if (item.children) {
      item.children.forEach((item) => {
        flatUnit(item, list);
      });
    }
  }

  chapterArr.forEach((item) => flatUnit(item, list));

  return list;
}

export interface ITempAgentDataInfo {
  icon_url: string;
  id: number;
  name: string;
  reference_count: number;
  status: string;
  create_at: string;
  update_at: string;
  publish_at: string;
}

export const initITempAgentDataInfo: ITempAgentDataInfo = {
  icon_url: '',
  id: 0,
  name: '',
  reference_count: 0,
  status: '',
  create_at: '',
  update_at: '',
  publish_at: '',
};

const initBookInfoData: IBookInfoData = {
  book_info: {
    grade: '3年级',
    name: 'AI伴我学作文',
    page_count: '75',
    publisher: '四川教育出版社',
    term: '下学期',
    title: 'https://ra.namibox.com/tina/static/v/publisher/川教版/title.png',
    unit_type: '',
    ai_product_book_rel_id: 0,
  },
  chapter_info: [],
  page_list: [],
  jsonurl: '',
};

export interface IContentCreate {
  unitid: string;
  bookList: IBookItemInfo[];
  bookData: IBookInfoData;
  flatChater: IBookInfoData['chapter_info'];
  activeGrounp: IConfigGrounpItem | null;
  activeGrounpChild: IGrounpChildItem | null;
  activeAgentInfo: IAgentInfo; // 当前智能体详情
  templateGroups: ITemplateGroupsItem[];

  shuxingChangedFlag: boolean; // 属性是否被更改
  variablesChangedFlag: boolean; // item 变量是否被更改
  productEngineList: IEngineTree[];
  flatProductEngineList: IEngineTree[];
  previewFreshFlag: boolean;
  freshPublishFlag: boolean;
  temList: ITemplateItem[];
}

interface IBookItemInfo {}

export interface IConfigGrounpItem {
  charge: 0 | 1;
  icon: string;
  id: number;
  seq: number;
  style: string;
  title: string;
  sub_title: string;
  ai_engine_id: number | string;
  ai_engine_type: string;
  items: IGrounpChildItem[];
}

export interface IAgentInfo {
  introduce: string; // 开场白
  model_name: string; // 类型
  img_list: string[]; // 图片
  prompt: string;
  id: number;
  name: string;
  template_id: number;
  isFromTem: boolean;
}

export const initAgentInfo: IAgentInfo = {
  introduce: '',
  model_name: '',
  img_list: [],
  prompt: '',
  id: 0,
  name: '',
  template_id: 0,
  isFromTem: false,
};

export interface IGrounpChildItem {
  ai_engine_id: number | null;
  icon: string;
  id: number;
  seq: number;
  sub_title: string;
  title: string;
  ai_engine_type?: string | null;
}

interface ITemplateItem {
  id: number;
  name: string;
}

export const initContentCreate: IContentCreate = {
  unitid: '',
  bookList: [],
  bookData: initBookInfoData,
  flatChater: [],
  activeGrounp: null,
  activeGrounpChild: null,
  activeAgentInfo: initAgentInfo,
  templateGroups: [],
  shuxingChangedFlag: false,
  variablesChangedFlag: false,
  productEngineList: [],
  flatProductEngineList: [],
  previewFreshFlag: false,
  freshPublishFlag: false,
  temList: [],
};

export function getUnitid(item: IChapterInfo): string {
  if (item?.children && item?.children?.length) {
    return getUnitid(item.children[0]);
  }
  return item?.is_content_unit ? `${item.id}` : '';
}

interface ITemplateGroupsItem {
  id: number;
  name: string;
  is_publish?: boolean;
  children?: ITemplateGroupsItem[];
}

export interface IEngineTree {
  id: number;
  template_id: number;
  name: string;
  seq: number;
  ai_engine_type: string;
  category: string;
  children?: IEngineTree[];
}

export interface IEngineItem {
  id: number;
  name: string;
  type: string;
  category: string;
  diagram: string;
  description: string;
  service_engine_js: string;
  service_engine_ts: string;
  chat_engine_url: string;
  chat_engine_version: string;
  last_modify_time: string;
  engine_data: IEngineDataItem[];
  engine_attr: any[];
  group_name: string;
}

interface IEngineDataItem {
  id: number;
  name: string;
  obj_id: number;
  obj_type: string;
  agent_name: string;
}
